import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgIf } from '@angular/common';

@Component({
  selector: 'iss-drawer-header',
  standalone: true,
  templateUrl: './drawer-header.component.html',
  styleUrls: [ './drawer-header.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ NgIf ],
})
export class DrawerHeaderComponent {
  @Input({ required: true }) public title!: string;
  @Input() public subtitle?: string;
}
